import { Image as ChakraImage } from '@chakra-ui/react';

export default ChakraImage;
